import { Activity, Clock, FileClock, Gauge, Timer, Zap } from "lucide-react";
import "./KpiTiles.scss";

const KpiTile = ({ icon: Icon, label, value, unit, color, maxValue, isInteger }) => {
  const numValue = value ?? 0;
  const percentage = maxValue ? Math.min((numValue / maxValue) * 100, 100) : 0;

  return (
    <div className="kpi_tile">
      <div className="kpi_icon" style={{ backgroundColor: color + "20" }}>
        <Icon size={24} color={color} />
      </div>
      <div className="kpi_content">
        <div className="kpi_label">{label}</div>
        <div className="kpi_value">
          {value !== null && value !== undefined
            ? (isInteger ? numValue.toLocaleString() : numValue.toFixed(2))
            : "—"}
          <span className="kpi_unit">{unit}</span>
        </div>
        <div className="kpi_gauge">
          <div
            className="kpi_gauge_fill"
            style={{ width: percentage + "%", backgroundColor: color }}
          />
        </div>
      </div>
    </div>
  );
};

const KpiTiles = ({ stats, timeSeries }) => {
  // Convert ms to seconds for display
  const ttftSeconds = stats?.avgTtftMs != null ? stats.avgTtftMs / 1000 : null;
  const durationSeconds =
    stats?.avgDurationMs != null ? stats.avgDurationMs / 1000 : null;

  // Calculate total requests from time series data
  const totalRequests = timeSeries?.points?.reduce(
    (sum, point) => sum + (point.count || 0),
    0
  ) ?? null;

  return (
    <div className="kpi_tiles">
      <KpiTile
        icon={Activity}
        label="Total Requests"
        value={totalRequests}
        unit=""
        color="#a78bfa"
        maxValue={1000}
        isInteger
      />
      <KpiTile
        icon={Timer}
        label="Avg Time to First Token"
        value={ttftSeconds}
        unit="s"
        color="#6366f1"
        maxValue={5}
      />
      <KpiTile
        icon={Gauge}
        label="Avg Tokens/Second"
        value={stats?.avgTokensPerSecond}
        unit="tok/s"
        color="#22c55e"
        maxValue={100}
      />
      <KpiTile
        icon={FileClock}
        label="Avg Duration"
        value={durationSeconds}
        unit="s"
        color="#f59e0b"
        maxValue={30}
      />
    </div>
  );
};

export default KpiTiles;
